module.exports = __webpack_public_path__ + "img/esgtree.7bce8644.png";